import { render, staticRenderFns } from "./StandardList.vue?vue&type=template&id=263bab08&scoped=true&"
import script from "./StandardList.vue?vue&type=script&lang=js&"
export * from "./StandardList.vue?vue&type=script&lang=js&"
import style0 from "./StandardList.vue?vue&type=style&index=0&id=263bab08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263bab08",
  null
  
)

export default component.exports